import { ThemeOptions } from "@mui/material"

/** Tesla-style light: minimal, flat, subtle borders, no frosted/glass. */
const teslaLightTheme: ThemeOptions = {
  palette: {
    mode: "light",
    primary: { main: "#1a1a1a", light: "#404040", dark: "#000000" },
    secondary: { main: "#4a4a4a", light: "#737373", dark: "#262626" },
    background: { default: "#fafafa", paper: "#ffffff" },
    text: { primary: "rgba(0, 0, 0, 0.88)", secondary: "rgba(0, 0, 0, 0.55)" },
    divider: "rgba(0, 0, 0, 0.08)"
  },
  typography: {
    fontFamily: "'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif",
    h1: { fontWeight: 600, letterSpacing: "-0.02em" },
    h2: { fontWeight: 600, letterSpacing: "-0.02em" },
    h3: { fontWeight: 600, letterSpacing: "-0.015em" },
    h4: { fontWeight: 600, letterSpacing: "-0.01em" },
    h5: { fontWeight: 600, letterSpacing: "-0.005em" },
    h6: { fontWeight: 600, letterSpacing: "0em" },
    subtitle1: { fontWeight: 500, letterSpacing: "0.01em" },
    button: { textTransform: "none", fontWeight: 600, letterSpacing: "0.01em" }
  },
  shape: { borderRadius: 6 },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: { background: "#fafafa", minHeight: "100vh", color: "rgba(0, 0, 0, 0.88)" },
        "::-webkit-scrollbar": { width: 8, height: 8 },
        "::-webkit-scrollbar-thumb": { backgroundColor: "rgba(0, 0, 0, 0.15)", borderRadius: 4 },
        "::-webkit-scrollbar-track": { background: "transparent" }
      }
    },
    MuiPaper: {
      styleOverrides: { root: { backgroundColor: "#ffffff", border: "1px solid rgba(0, 0, 0, 0.08)", borderRadius: 6, boxShadow: "none" } }
    },
    MuiCard: {
      styleOverrides: {
        root: { backgroundColor: "#ffffff", border: "1px solid rgba(0, 0, 0, 0.08)", borderRadius: 6, padding: 8, boxShadow: "none" }
      }
    },
    MuiAppBar: {
      styleOverrides: { root: { backgroundColor: "#ffffff", borderBottom: "1px solid rgba(0, 0, 0, 0.08)", boxShadow: "none" } }
    },
    MuiDrawer: {
      styleOverrides: { paper: { backgroundColor: "#fafafa", borderRight: "1px solid rgba(0, 0, 0, 0.08)", boxShadow: "none" } }
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: "#ffffff",
          border: "1px solid rgba(0, 0, 0, 0.08)",
          borderRadius: 6,
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.08)"
        }
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: { backgroundColor: "rgba(0, 0, 0, 0.85)", color: "#fff", fontWeight: 500, border: "none", borderRadius: 4 }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          padding: "6px 16px",
          fontWeight: 600,
          letterSpacing: "0.01em",
          transition: "background-color 0.2s ease, border-color 0.2s ease",
          border: "1px solid rgba(0, 0, 0, 0.12)",
          backgroundColor: "#ffffff",
          color: "rgba(0, 0, 0, 0.88)",
          boxShadow: "none",
          "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.04)", borderColor: "rgba(0, 0, 0, 0.2)", boxShadow: "none" },
          "&:active": { backgroundColor: "rgba(0, 0, 0, 0.08)" },
          "&.Mui-disabled": { backgroundColor: "rgba(0, 0, 0, 0.02)", color: "rgba(0, 0, 0, 0.35)", borderColor: "rgba(0, 0, 0, 0.08)" }
        },
        contained: {
          backgroundColor: "#1a1a1a",
          color: "#ffffff",
          borderColor: "transparent",
          "&:hover": { backgroundColor: "#333333" },
          "&.Mui-disabled": { backgroundColor: "rgba(0, 0, 0, 0.12)", color: "rgba(0, 0, 0, 0.35)" }
        },
        outlined: {
          borderColor: "rgba(0, 0, 0, 0.2)",
          "&:hover": { borderColor: "rgba(0, 0, 0, 0.4)", backgroundColor: "rgba(0, 0, 0, 0.04)" }
        },
        text: { border: "none", backgroundColor: "transparent", "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.04)" } }
      }
    },
    MuiTableContainer: {
      styleOverrides: { root: { backgroundColor: "#ffffff", border: "1px solid rgba(0, 0, 0, 0.08)", borderRadius: 6, boxShadow: "none" } }
    }
  }
}

export default teslaLightTheme
